/** React Flow node-type registry for Production Canvas.
 * Kept in its own module so node-test gates can validate imports without
 * pulling in the full CanvasBoard orchestration graph. */

import ActionNode from './nodes/ActionNode'
import EntityNode from './nodes/EntityNode'
import GenerateImageNode from './nodes/GenerateImageNode'
import GenerateAudioNode from './nodes/GenerateAudioNode'
import GenerateVoiceTemplateNode from './nodes/GenerateVoiceTemplateNode'
import GenerateTryOnNode from './nodes/GenerateTryOnNode'
import ApparelVideoReplicationNode from './nodes/ApparelVideoReplicationNode'
import GenerateVideoNode from './nodes/GenerateVideoNode'
import ImageAssetNode from './nodes/ImageAssetNode'
import VideoAssetNode from './nodes/VideoAssetNode'
import AudioAssetNode from './nodes/AudioAssetNode'
import TextAssetNode from './nodes/TextAssetNode'
import MotionAssetNode from './nodes/MotionAssetNode'
import MotionReconstructionNode from './nodes/MotionReconstructionNode'
import SceneNode from './nodes/SceneNode'
import ProjectStartNode from './nodes/ProjectStartNode'
import CreativeCandidateNode from './nodes/CreativeCandidateNode'
import GenerateCreativeNode from './nodes/GenerateCreativeNode'
import ScriptGenerationNode from './nodes/ScriptGenerationNode'
import StoryboardGenerationNode from './nodes/StoryboardGenerationNode'
import GenerateTextNode from './nodes/GenerateTextNode'
import type { NodeTypes } from '@xyflow/react'

export const CANVAS_NODE_TYPES: NodeTypes = {
  entity: EntityNode,
  action: ActionNode,
  scene: SceneNode,
  media: ImageAssetNode,
  video_media: VideoAssetNode,
  audio_asset: AudioAssetNode,
  generator: GenerateImageNode,
  video_generator: GenerateVideoNode,
  voice_generator: GenerateVoiceTemplateNode,
  audio_generator: GenerateAudioNode,
  text_asset: TextAssetNode,
  motion_asset: MotionAssetNode,
  motion_processor: MotionReconstructionNode,
  tryon_generator: GenerateTryOnNode,
  apparel_video_generator: ApparelVideoReplicationNode,
  project_start: ProjectStartNode,
  creative_candidate: CreativeCandidateNode,
  generate_creative: GenerateCreativeNode,
  script_generation: ScriptGenerationNode,
  storyboard_generation: StoryboardGenerationNode,
  text_generator: GenerateTextNode,
}

export const CANVAS_NODE_TYPE_KEYS = Object.keys(CANVAS_NODE_TYPES) as Array<keyof typeof CANVAS_NODE_TYPES>
